var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "green"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.91 8.204l-6.85 9.29a1.01 1.01 0 01-.68.4c-.13.02-.27 0-.4-.03-.13-.04-.25-.1-.36-.18l-4.88-3.91a.913.913 0 01-.25-.3c-.06-.12-.1-.24-.12-.37a.87.87 0 01.04-.39c.04-.13.1-.24.18-.35.17-.2.4-.33.66-.36.26-.03.52.05.73.21l4.08 3.26 6.24-8.47c.16-.21.39-.35.65-.39a1.021 1.021 0 011.01.47c.07.11.12.24.14.37a1.017 1.017 0 01-.19.75z",
    fill: "#fff"
  })));
}
export default SvgIconCheckCircle24;